import { useEffect, useState } from "react";
import FormModal from "../../widgets/FormModal";
import { Link } from "react-router-dom";
import Header from "../../widgets/Header";
import Footer from "../../widgets/Footer";


function StudyRevealsRunning() {
    const [show, setShow] = useState(false);
    const openIframeWindow = () => {
        setShow(!show);
    }

    return (
        <> <section className="light_bg">
            <Header />
            <div className="top_space"></div>

            <section className="ps">
                <div className="container">
                    <h1 className="hadding">Study Reveals Running Marathons or Doing Endurance Exercises Are Not Indications of Good Heart Health</h1>
                    <p className="op0_5">By Dr. Sajeev Nair, K.R. Reshma & Team</p>
                    <div className="position-relative  mt-4 mb-4">
                        <img src="/assets/img/research/study-reveals-running.webp" alt="study-reveals-running" className="w100 br20" />
                    </div>
                    <h3 className="op0_8">Abstract </h3>
                    <p>Endurance sports such as marathon running are commonly regarded as symbols of cardiovascular strength. However, recent genetic research challenges this belief. This study analyzed 500 EPLIMO genetic predisposition reports of individuals identified with high-endurance potential genotypes.
                        The results revealed that while these individuals may be genetically primed for superior endurance performance, a significant proportion simultaneously carried genetic risks for heart failure, Long QT Syndrome (LQTS), and magnesium deficiency–related arrhythmia susceptibility.
                        These findings underscore the importance of a personalized, genetic approach to exercise planning, cautioning against assuming that endurance training automatically translates to good heart health. Personalized wellness programs like EPLIMO can help mitigate hidden cardiac risks and ensure safer, optimized training outcomes. </p>



                    <h3 className="op0_8">Introduction </h3>
                    <p>
                        Endurance training, including marathons, triathlons, and long-distance sports, has long been associated with improved health, vitality, and longevity. Yet, emerging genetic evidence reveals that endurance capacity and cardiac resilience are not always aligned. While some individuals inherit genetic advantages that support endurance performance, others carry cardiac risk variants that may increase their susceptibility to heart complications during or after sustained exertion.
                        The EPLIMO Genetic Predisposition Test, which analyzes over 275 genetic markers, provides valuable insights into these dual factors, evaluating both endurance potential and underlying cardiac vulnerabilities. This study aimed to assess the relationship between endurance capacity genes and cardiovascular risk variants, focusing on heart failure, LQTS, and magnesium deficiency. </p>


                    <h3 className="op0_8">Methodology </h3>
                    <p>Study Design: Retrospective genetic data analysis.
                    </p><p>
                        Data Source: 500 EPLIMO genetic predisposition reports from individuals identified with high-endurance genotypes.
                    </p>
                    Analysis Parameters:
                    <ul class="mb-4 dot_list">
                        <li>Genetic Risk for Heart Failure </li>
                        <li>Genetic Risk for Long QT Syndrome (LQTS) </li>
                        <li>Genetic Risk for Magnesium Deficiency </li>
                    </ul>
                    <p>The analysis was conducted by the Genetic Counselling Team at Vieroots Wellness Solutions. </p>

                    <h3 className="op0_8">Results </h3>
                    <p>
                        Heart Failure Risk: Out of 500 individuals with endurance genes, 346 (69.2%) carried a genetic predisposition to heart failure.
                    </p>

                    <p>
                        Long QT Syndrome (LQTS): Among those predisposed to heart failure, 243 (70.2%) carried LQTS-associated variants, which increase the likelihood of dangerous arrhythmias during prolonged exertion. </p>
                    <p>

                        Magnesium Deficiency Connection: 230 individuals with LQTS risk also showed magnesium deficiency–related genetic variants, which can intensify QT prolongation and destabilize cardiac rhythm.
                    </p>

                    <p>
                        These overlapping risks reveal that high endurance potential often coexists with significant cardiac vulnerability.
                    </p>
                    <h3 className="op0_8"> Discussion</h3>
                    <p> The findings fundamentally challenge the popular assumption that endurance exercise equates to cardiovascular fitness. Nearly 7 out of 10 individuals genetically equipped for endurance also carried cardiac risk genes.</p>
                    <p>
                        LQTS is a well-documented cause of exercise-induced arrhythmias and sudden cardiac death. The additional presence of magnesium deficiency genes, a factor that disrupts ion balance and myocardial excitability, further compounds the risk. </p>
                    <p>
                        This evidence suggests that endurance athletes and trainers must move beyond performance metrics and adopt a genetics-informed approach to wellness. Without personalized assessment, prolonged training could inadvertently trigger cardiac events in susceptible individuals.</p>

                    <h3 className="op0_8">Implications </h3>

                    <ul class="mb-4 dot_list">
                        <li>For Athletes: Genetic testing should be conducted before initiating endurance programs to identify hidden cardiac risks. </li>
                        <li>For Clinicians: Endurance ability should not be assumed to reflect cardiac safety; genetic screening can reveal underlying risks. </li>
                        <li>For the Public: Personalized lifestyle guidance through EPLIMO enables tailored nutrition, supplementation, and exercise strategies that support both performance and heart health. </li>
                    </ul>

                    <h3 className="op0_8">Conclusion </h3>
                    <p> This study provides strong genetic evidence that marathon running or endurance exercise is not inherently an indicator of good heart health. Genetic predispositions to heart failure, Long QT Syndrome, and magnesium deficiency can coexist with endurance potential, posing unseen risks during intense physical activity.</p>
                    <p>
                        EPLIMO’s integrated genetic and lifestyle assessment offers a precision-based preventive approach, helping individuals train safely while protecting long-term cardiovascular health. </p>


                    <div className="pt-4 text-center">
                        <a href="genetic-research" className="back_btn bn_btn"><i className="bi bi-chevron-left"></i></a>
                        <a href="study-reveals-correlation" className="next_btn bn_btn"><i className="bi bi-chevron-right"></i></a>
                    </div>

                </div>

            </section>


            <section className="you_ready_sec text-white position-relative  overflow-hidden">
                <img src="/assets/img/research/research_r_bg.webp" alt="cour raddy" className="cour_raddy mo_none" />
                <img src="/assets/img/research/research_r_bg2.webp" alt="cour raddy" className="cour_raddy pc_none" />

                <div className="container position-relative">
                    <div className="row position-relative">
                        <div className="col-md-5  ms-auto">
                            <h2 className="hadding mb-4    ">Are You Ready to Take Control of Your Future Health?</h2>
                            <p className=" mb-md-4 mb-3 ">EPLIMO is more than a health check. It’s a blueprint for living stronger,
                                longer, and happier. Don’t wait for symptoms to become problems. Take charge today and start
                                living at your peak.</p>
                            <a className="btn" onClick={() => openIframeWindow()}>Join EPLIMO<sup className="sup-font">TM</sup> Program</a>
                        </div>
                    </div>
                </div>
            </section>
            <FormModal show={show} setShow={setShow} />
            <Footer /> </section>
        </>
    );
}

export default StudyRevealsRunning;
